import React, { useState } from "react";
import Header from "./Header";
import Faqs from "./Faqs";
import UserManual from "./UserManual";
import { Link } from "react-router-dom";
import { goBack } from "../CommonJquery/CommonJquery";
import { Button } from "@mui/material";
import { ArrowLeft } from "lucide-react";
function Manuals() {
  const [calendarTab, setCalendarTab] = useState(true);
  const [historyTab, setHistoryTab] = useState(false);

  const toggleTabs = (Tab) => {
    if (Tab === "Calender") {
      window.location.reload();
    }
    setCalendarTab(Tab === "Calender");
    setHistoryTab(Tab === "History");
  };

  return (
    <div className="dashboard">
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head mb-3">
              <div className="calendertabs">
                <div className="calendertabs_container">
                  <div
                    className={`calendertabsBtn width150px ${
                      calendarTab ? "activeCalendarTab" : ""
                    }`}
                    onClick={() => toggleTabs("Calender")}
                  >
                    <p>FAQs</p>
                  </div>
                  <div
                    className={`calendertabsBtn width150px ${
                      historyTab ? "activeCalendarTab" : ""
                    }`}
                    onClick={() => toggleTabs("History")}
                  >
                    <p>Knowledge Base</p>
                  </div>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>
            <div
              className="d-flex justify-content-end"
              style={{ marginRight: "1rem" }}
            >
              <div className="tabsBtn">
                {calendarTab && (
                  <Link to="/Add_Faq">
                    <button
                      type="button"
                      className="btnAddStaff darkBg add_FAQ"
                    >
                      Add FAQ
                    </button>
                  </Link>
                )}
                {historyTab && (
                  <Link to="/Add_KB">
                    <button
                      type="button"
                      className="btnAddStaff darkBg add_User_Manual"
                    >
                      Add User Manual
                    </button>
                  </Link>
                )}
              </div>
            </div>

            <div className="page_body">
              {calendarTab && <Faqs />}
              {historyTab && <UserManual />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Manuals;
